import Button from '@anm/components/buttons/Button';
import useDownloadCsv from '@anm/hooks/useDownloadCsv';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { analyticsSelectors } from '../../../../../../store/modules/analytics';
import { projectSelectors } from '../../../../../../store/modules/project';

import { getPlaysReportTable, getViewsReport } from './helpers';

const ButtonWrapper = styled(Button)`
  max-width: 146px;
`;

const ExportAsCVS: FC = () => {
  const engagementData = useSelector(analyticsSelectors.selectAggregateEngagementViews);
  const totalTimePlayedData = useSelector(state => analyticsSelectors.selectPeriodDataByKey(state, 'timePlayed'));
  const viewCountsData = useSelector(state => analyticsSelectors.selectPeriodDataByKey(state, 'plays'));

  const playsReportData = getPlaysReportTable(viewCountsData, totalTimePlayedData);
  const viewsReportData = getViewsReport(engagementData);
  const downloadPlaysReportCsv = useDownloadCsv({
    data: [playsReportData],
    fileName: 'plays_report.csv'
  });
  const downloadViewsCsv = useDownloadCsv({
    data: [viewsReportData],
    fileName: 'views_report.csv'
  });

  const downloadCsv = useCallback(() => {
    downloadViewsCsv();
    downloadPlaysReportCsv();
  }, [downloadPlaysReportCsv]);

  const isProjectEverRender = useSelector(projectSelectors.selectCurrentProjectEverRendered);

  return (
    <ButtonWrapper variant="silver" size="medium" onClick={downloadCsv} disabled={!isProjectEverRender}>
      Export as csv
    </ButtonWrapper>
  );
};

export default ExportAsCVS;
